import Vue from 'vue';

Vue.component('datatable-loader', require('./datatable-loader.vue'));



// WEBPACK FOOTER //
// ./resources/assets/js/components/datatable-loader/index.js